import { DateTime, Settings } from "luxon";

Settings.defaultLocale = document.documentElement.lang || "en";
Settings.defaultZone = document.documentElement.dataset.timezone || "UTC";

const initialState = {
  loading: false,
  shifts: [],
  schedule: {
    start_date: DateTime.now(),
    number_of_days: 7,
    day_jump_size: 1,
    save_status: false,
  },
};

export default function scheduleReducer(state = initialState, action) {
  switch (action.type) {
    case "SCHEDULE_UPDATE_START_DATE":
      return {
        ...state,
        schedule: {
          ...state.schedule,
          start_date: action.payload instanceof DateTime ? action.payload : DateTime.fromISO(action.payload),
        },
      };
    case "SCHEDULE_UPDATE_NUMBER_OF_DAYS":
      return {
        ...state,
        schedule: {
          ...state.schedule,
          number_of_days: action.payload,
        },
      };
    case "SCHEDULE_SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SCHEDULE_SET_SHIFTS":
      return {
        ...state,
        shifts: action.payload,
      };
    case "SCHEDULE_SET_SAVE_STATUS":
      return {
        ...state,
        schedule: {
          ...state.schedule,
          save_status: action.payload,
        },
      };
    default:
      return state;
  }
}

